export enum visitStatus {
    EN_CURSO = 1,
    FEEDBACK_PENDIENTE = 2,
    FEEDBACK_DISPONIBLE = 3
}